import { useClipboard } from '@vueuse/core'
import { useStore } from '@/store'

export function useCopyNotify() {
  const store = useStore()
  const { copy } = useClipboard()

  const copyWithNotify = (text, label) => {
    if (!text) return
    copy(text)
    store.commit('notify', {
      type: 'success',
      message: label ? `Copied ${label} to clipboard!` : 'Copied to clipboard!',
    })
  }

  return { copyWithNotify }
}
